import {
  EXPORT_CASE_REPORT_FORMS,
  LOGS,
  PATIENT_INFO,
  PATIENT_PROFILE,
  PL,
  REIMBURSEMENT_REQUEST,
  TRAVEL_REQUEST,
  VIEW_ALL_LOGS
} from '../../../constants/accessToPages';
import CalendarPage from '../../pages/Calendar/CalendarPage';
import withPatientProvided from '../../pages/Calendar/withPatientProvided';
import ExportCaseReportForms from '../../pages/patient-source/Patients/ExportCaseReportForms/ExportCaseReportForms';
import LogRowHistory from '../../pages/patient-source/Patients/Logs/LogsHistory/LogRowHistory';
import LogsPage from '../../pages/patient-source/Patients/Logs/LogsPage';
import CompletedICFPage from '../../pages/patient-source/Patients/PatientInfo/ICFSection/CompletedICFPage';
import PatientInfo from '../../pages/patient-source/Patients/PatientInfo/PatientInfo';
import ReimbursementRequest from '../../pages/patient-source/Patients/PatientInfo/ReimbursementRequest/ReimbursementRequest';
import TravelRequest from '../../pages/patient-source/Patients/PatientInfo/TravelRequest/TravelRequest';
import ViewAllLogs from '../../pages/patient-source/Patients/PatientInfo/ViewAllLogs/ViewAllLogs';
import MedicalHistory from '../../pages/patient-source/Patients/PatientProfile/MedicalHistory/MedicalHistory';
import Medications from '../../pages/patient-source/Patients/PatientProfile/Medications/Medications';
import PatientDetails from '../../pages/patient-source/Patients/PatientProfile/PatientDetails/PatientDetails';
import PatientFiles from '../../pages/patient-source/Patients/PatientProfile/PatientFiles/PatientFiles';
import PatientProfile from '../../pages/patient-source/Patients/PatientProfile/PatientProfile';
import PatientStudies from '../../pages/patient-source/Patients/PatientProfile/PatientStudies';
import PatientStatusChange from '../../pages/patient-source/Patients/PatientStatusChange/PatientStatusChange';
import EncounterDescription from '../../pages/patient-source/shared/EncounterDescNew/encounterDescNew';
import GetDomainDetailsElement from '../../pages/patient-source/shared/EncounterDescNew/getDomainDetailElements';
import TableItemGroup from '../../pages/patient-source/shared/EncounterDescNew/TableItemGroup/TableItemGroup';
import InformedConsent from '../../pages/patient-source/shared/NewEncounterPage/InformedConsent/InformedConsent';
import NewEncounterPage from '../../pages/patient-source/shared/NewEncounterPage/NewEncounterPage';
import { withNewEncounterPageContext } from '../../pages/patient-source/shared/NewEncounterPage/NewEncounterPageContext';
import { emitOnUpdate } from '../../pages/patient-source/shared/NewEncounterPage/onUpdateEventEmmiterService';
import { ReviewPageDEV } from '../../pages/patient-source/shared/ReviewDEV/ReviewPage';

import { forceRemount } from './service';
import { withMultiAccess } from './withMultiAccess';

export function generatePatientInfoRouterConfig(itemGroupAccess, smReviewAccess) {
  return [
    {
      name: 'Patient Profile',
      path: '/:patientId',
      component: PatientProfile,
      access: [PATIENT_PROFILE],
      nested: [
        {
          name: 'Patient Details',
          path: '/tab/details',
          component: PatientDetails
        },
        {
          name: 'Studies',
          path: '/tab/studies',
          component: PatientStudies
        },
        {
          name: 'Medications',
          path: '/tab/medications',
          component: Medications
        },
        {
          name: 'Medical History',
          path: '/tab/history',
          component: MedicalHistory
        },
        {
          name: 'Patient Files',
          path: '/tab/files',
          component: PatientFiles
        }
      ],
      inherited: [
        {
          name: 'Patient Studies',
          path: '/:ssuPatientId',
          component: PatientInfo,
          access: [PATIENT_INFO],
          inherited: [
            { name: 'Viewing All Logs', path: '/all-logs', component: ViewAllLogs, access: [VIEW_ALL_LOGS] },
            {
              name: 'Encounter Details',
              path: '/encounters/:patientEncounterId',
              component: withMultiAccess(NewEncounterPage),
              inherited: [
                {
                  name: 'Investigator Encounter Review',
                  path: '/inv-encounter-review/:groupAssignId/signature/:signatureId',
                  component: withMultiAccess(ReviewPageDEV),
                  access: [itemGroupAccess]
                },
                {
                  name: 'Study Manager Encounter Review',
                  path: '/sm-encounter-review/:groupAssignId/signature/:signatureId',
                  component: withMultiAccess(ReviewPageDEV),
                  access: [smReviewAccess]
                }
              ],
              nested: [
                {
                  name: 'Procedure',
                  path: '/item-groups/:patientItemGroupId',
                  component: withNewEncounterPageContext(
                    forceRemount(function(props) {
                      return <GetDomainDetailsElement {...props} inheritedComponent onSubmit={emitOnUpdate} />;
                    })
                  ),
                  access: [itemGroupAccess]
                },
                {
                  name: 'Table',
                  path: '/table-groups/:patientItemGroupId',
                  component: forceRemount(function(props) {
                    return <TableItemGroup {...props} />;
                  }),
                  access: [itemGroupAccess]
                },
                {
                  name: 'Informed Consent',
                  path: '/icf/:patientItemGroupId/:typeId/:languageId',
                  component: forceRemount(function(props) {
                    return <InformedConsent {...props} />;
                  }),
                  access: [itemGroupAccess]
                },
                {
                  name: 'Logs',
                  path: '/logs/:patientItemGroupId',
                  component: forceRemount(function(props) {
                    return <LogsPage {...props} inheritedComponent />;
                  }),
                  access: [PL],
                  inherited: [
                    {
                      name: 'Row',
                      path: '/:itemGroupTemplateVersionId/row/:rowId',
                      component: withNewEncounterPageContext(
                        forceRemount(function(props) {
                          return <GetDomainDetailsElement {...props} inheritedComponent onSubmit={emitOnUpdate} />;
                        })
                      ),
                      access: [PL],
                      inherited: [
                        {
                          name: 'History',
                          path: '/history',
                          component: LogRowHistory,
                          access: [PL]
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              name: 'Logs',
              path: '/logs/:patientItemGroupId',
              component: withMultiAccess(LogsPage),
              access: [LOGS],
              inherited: [
                {
                  name: 'Row',
                  path: '/:itemGroupTemplateVersionId/row/:rowId',
                  component: withMultiAccess(
                    forceRemount(function(props) {
                      return <GetDomainDetailsElement {...props} />;
                    })
                  ),
                  access: [LOGS],
                  inherited: [
                    {
                      name: 'History',
                      path: '/history',
                      component: withMultiAccess(LogRowHistory),
                      access: [LOGS]
                    }
                  ]
                }
              ]
            },
            {
              name: 'Completed Informed Consents',
              path: '/completed-informed-consents',
              component: CompletedICFPage,
              access: [PL]
            },
            {
              name: 'Create Unexpected Encounter',
              path: '/create-unexpected-encounter',
              component: EncounterDescription
            },
            {
              name: 'Edit Unexpected Encounter',
              path: '/edit-unexpected-encounter/:patientEncounterId',
              component: EncounterDescription
            },
            {
              name: 'Calendar',
              path: '/calendar',
              component: withPatientProvided(CalendarPage)
            },
            {
              name: 'Patient Status',
              path: '/patient-status',
              component: PatientStatusChange,
              access: [PL]
            },
            {
              name: 'Export Case Report Forms',
              path: '/export-case-report-forms',
              component: ExportCaseReportForms,
              access: [EXPORT_CASE_REPORT_FORMS]
            },
            {
              name: 'Reimbursement request',
              path: '/reimbursements/:reimbursementId',
              component: ReimbursementRequest,
              access: [REIMBURSEMENT_REQUEST]
            },
            {
              name: 'New Travel Request',
              path: '/travel-request',
              component: TravelRequest,
              access: [TRAVEL_REQUEST]
            },
            {
              name: 'Travel Request',
              path: '/travel-request/:travelRequestId',
              component: TravelRequest,
              access: [TRAVEL_REQUEST]
            }
          ]
        }
      ]
    },
    {
      name: 'Adverse Event Log Review',
      path: '/:ssuPatientId/adverse-event-log/:patientItemGroupId',
      component: LogsPage,
      access: [itemGroupAccess]
    },
    {
      /*TODO: Looks like an incorrect route structure (inheritance). It appears that this route is only used on worklist pages.*/
      name: 'Protocol Deviation Log Review',
      path: '/:ssuPatientId/deviation-log/:patientItemGroupId',
      component: LogsPage,
      access: [itemGroupAccess]
    },
    {
      /*TODO: Looks like an incorrect route structure (inheritance). It appears that this route is only used on worklist pages.*/
      name: 'Adverse Event Log Row',
      path: '/:ssuPatientId/adverse-event-log/:patientItemGroupId/:itemGroupTemplateVersionId/row/:rowId',
      component: forceRemount(function(props) {
        return <GetDomainDetailsElement {...props} />;
      }),
      access: [itemGroupAccess],
      inherited: [
        {
          name: 'History',
          path: '/history',
          component: LogRowHistory,
          access: [itemGroupAccess]
        }
      ]
    },
    {
      /*TODO: Looks like an incorrect route structure (inheritance). It appears that this route is only used on worklist pages.*/
      name: 'Protocol Deviation Log Row',
      path: '/:ssuPatientId/deviation-log/:patientItemGroupId/:itemGroupTemplateVersionId/row/:rowId',
      component: forceRemount(function(props) {
        return <GetDomainDetailsElement {...props} />;
      }),
      access: [itemGroupAccess],
      inherited: [
        {
          name: 'History',
          path: '/history',
          component: LogRowHistory,
          access: [itemGroupAccess]
        }
      ]
    }
  ];
}
